import { render, staticRenderFns } from "./HoseSettings.vue?vue&type=template&id=f8013b8e&scoped=true"
import script from "./HoseSettings.vue?vue&type=script&lang=js"
export * from "./HoseSettings.vue?vue&type=script&lang=js"
import style0 from "./HoseSettings.vue?vue&type=style&index=0&id=f8013b8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8013b8e",
  null
  
)

export default component.exports